<template>
	<div :class="'img-' + size" class="custom-icon">
		<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M90.486 127.987a43.098 43.098 0 01-30.016-11.158 45.79 45.79 0 00-1.451-1.184c-.2-.16-24.357-20.428-40.803-38.569C.052 56.701-.494 29.118 9.454 14.21A26.028 26.028 0 0131.32 2c4.94 0 8.775 4.216 10.24 8.14l7.311 23.42a13.074 13.074 0 01-2.903 12.448l-6.485 6.477c-1.425 1.437-2.064 4.35-1.492 5.48 1.412 2.832 4.861 8.152 13.21 17.422a84.466 84.466 0 0021.307 16.585 2.666 2.666 0 001.558.279 7.996 7.996 0 003.995-1.516l7.191-6.783a11.275 11.275 0 018.203-2.94c1.47.078 2.919.392 4.288.932l23.464 10.413a10.25 10.25 0 015.447 11.864c-2.663 7.594-10.227 20.64-30.868 23.327-1.714.336-3.46.483-5.207.439h-.093z" class="path" stroke="#0C2340"/><path d="M71.406 33.245c7.432-.1 13.593 2.296 18.484 7.187 4.89 4.89 7.312 11.077 7.262 18.559M68.753 19.295c13.353-.447 23.85 3.15 31.491 10.791 7.641 7.641 11.235 18.135 10.783 31.483M68 3.002c16.87-.123 31.017 5.528 42.442 16.953s17.077 25.573 16.955 42.444" class="highlight" stroke="#00BBDC"/></g></svg>
	</div>
</template>

<script>
export default {
	props: {
		size: {
			type: String,
			default: '4x'
		}
	}
}
</script>